var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 2.66666V10.2857H2.30955V2.66666H11.8334ZM12.7857 0.761902H1.35717C0.833357 0.761902 0.404785 1.19047 0.404785 1.71428V11.2381C0.404785 11.7619 0.833357 12.1905 1.35717 12.1905H12.7857C13.3095 12.1905 13.7381 11.7619 13.7381 11.2381V7.90476L17.5476 11.7143V1.23809L13.7381 5.04762V1.71428C13.7381 1.19047 13.3095 0.761902 12.7857 0.761902Z",
    fill: "#242D30"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9047f6d9574021b05571ab22a02d5c57.svg";
export { ForwardRef as ReactComponent };